// ********************************************************
// Archive
// Handles asphalt-delivery archive loading/saving
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadDeliveries (params) {
  const res = await Backend.callApi({
    apiName: 'AsphaltDelivery.LoadDeliveries',
    inputData: {
      // MITH special: If params is '' show all deliveries for all facilities (we use facility = null)
      Facility: params.facility === '' ? null : params.facility,
      DateTimeEarliest: params.dateTimeEarliest + ' 00:00:00',
      DateTimeLatest: params.dateTimeLatest + ' 23:59:59',
      AgreementNo: params.agreementNo
    }
  })
  return res.data
}

export async function saveAsphaltDeliveriesDetails (delivery) {
  const res = await Backend.callApi({
    apiName: 'AsphaltDelivery.SaveAsphaltDeliveriesDetails',
    inputData: {
      Deliveries: [delivery]
    }
  })
  return res
}

export async function loadVehicles (param) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicles',
    inputData: {
      // MITH special: If facility is '' show all vehicles for all facilities (we use facility = null).
      Facility: param.facility === '' ? null : param.facility,
      SearchText: param.searchText,
      LoadDeleted: param.loadDeleted !== null ? param.loadDeleted : true // load Deleted, if we need to show all inactive Vehicles
    }
  })
  return res
}

export async function loadVehicle (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicle',
    inputData: {
      Facility: params.facilityNo,
      No: params.vehicleNo
    }
  })
  return res
}

export async function saveVehiclesAndUsers (vehicle) {
  const res = await Backend.callApi({
    apiName: 'AsphaltDelivery.SaveVehiclesAndUsers',
    inputData: {
      Vehicles: [vehicle]
    }
  })
  return res
}

export async function isVehicleUser () {
  const res = await Backend.callApi({
    apiName: 'AsphaltDelivery.IsVehicleUser',
    inputData: { }
  })
  return res
}
